const Backbone = require('backbone');

module.exports = Backbone.View.extend({
	el: '.js-product-vendor',

	events: {
		'click .js-show-return-rates': '_showReturnRates',
		'click .js-vendor-toggle-all': '_toggleAllVendors',
		'click .js-vendor-toggle': '_toggleVendor'
	},

	initialize() {
		$('.js-internal-stock-status').on('click', this._expandAllVendors.bind(this));
	},

	_vendors() {
		return this.$el.find('.js-vendor-info');
	},

	_showReturnRates(event) {
		event.preventDefault();
		if (this.childViews.returnRatesModal) {
			this.childViews.returnRatesModal.render();
		} else {
			const compositeId = parseInt($(event.currentTarget).data('compositeId'), 10) || 0;
			import('app/views/store/pages/products/return_rates_modal').then((ReturnRatesModalView) => {
				this.childViews.returnRatesModal = new ReturnRatesModalView({
					compositeId
				});
			});
		}
	},

	_toggleAllVendors(event) {
		const $target = $(event.currentTarget);
		const expanded = $target.data('expanded');
		if (expanded) {
			this._collapseAllVendors();
		} else {
			this._expandAllVendors();
		}
	},

	_toggleVendor(event) {
		const $vendorInfo = $(event.currentTarget).closest('.js-vendor-info');
		const expanded = $vendorInfo.data('expanded');
		if (expanded) {
			this._collapseVendor($vendorInfo);
		} else {
			this._expandVendor($vendorInfo);
		}
	},

	_expandAllVendors() {
		const $toggleAll = this.$el.find('.js-vendor-toggle-all');
		$toggleAll.data('expanded', true);
		$toggleAll.removeClass('ico-chevron-down').addClass('ico-chevron-up');
		this._vendors().each((index, element) => {
			const $vendorInfo = $(element);
			this._expandVendor($vendorInfo);
		});
	},

	_collapseAllVendors() {
		const $toggleAll = this.$el.find('.js-vendor-toggle-all');
		$toggleAll.data('expanded', false);
		$toggleAll.removeClass('ico-chevron-up').addClass('ico-chevron-down');
		this._vendors().each((index, element) => {
			const $vendorInfo = $(element);
			this._collapseVendor($vendorInfo);
		});
	},

	_expandVendor($vendorInfo) {
		$vendorInfo.find('.js-vendor-notes').removeClass('text-clamp2');
		$vendorInfo.find('.js-vendor-stock-table').slideDown(100);
		$vendorInfo
			.find('.js-vendor-toggle')
			.removeClass('ico-chevron-down')
			.addClass('ico-chevron-up');
		$vendorInfo.data('expanded', true);
	},

	_collapseVendor($vendorInfo) {
		$vendorInfo.find('.js-vendor-notes').addClass('text-clamp2');
		$vendorInfo.find('.js-vendor-stock-table').slideUp(100);
		$vendorInfo
			.find('.js-vendor-toggle')
			.removeClass('ico-chevron-up')
			.addClass('ico-chevron-down');
		$vendorInfo.data('expanded', false);
	}
});
